import * as React from "react";
import { AudioEnum } from "../../../enums";
import { getAudio } from "../../../utils/AudioUtils";
// eslint-disable-next-line max-len
import AudioPlayerNonInteractiveEffect from "../../Common/AudioPlayer/AudioEffect/AudioPlayerNonInteractiveEffect";

interface Props {
  classStatus?: string;
  value: number;
}

const WheelSlice: React.FC<Props> = ({ classStatus, value }) => (
  <li className={`wheel_slice ${classStatus}`}>
    {classStatus?.includes("inlight light") && (
      <AudioPlayerNonInteractiveEffect
        audioEffectToBePlayed={getAudio(AudioEnum.EFFECT_ROULETTE_TICK)}
      />
    )}
    <div className="slice" />
    <div className="text">{value}</div>
  </li>
);

WheelSlice.defaultProps = {
  classStatus: "",
};

export default WheelSlice;
